module.exports = __webpack_public_path__ + "static/media/reports/Kevin_Ferrone_signature.jpg";